import controller from './query-classes-tree.controller';
import template from './query-classes-tree.html';
import './query-classes-tree.scss';

export default {
	bindings: {
		class:       '@?',
		classes:     '<ngModel',
		children:    '<children',
		disabled:    '<?ngDisabled',
		onDragEnd:   '&',
		onDragStart: '&',
		parent:      '<?',
	},
	controller,
	require:  {
		editor:       '^^?queryEditor',
		ngModelCtrl:  'ngModel',
		queryClasses: '^^?queryClasses',
	},
	template,
};
